import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

declare var $: any;

@Injectable()
export class NumberFormatting {

  constructor(
    public datePipe: DatePipe,
  ) { }

  RoundDecimal(decimals, value) {
    const valueString = value.toString().replace(',', '.');

    value = parseFloat(valueString);
    if (decimals !== 0) {
      value = Math.round(value * (decimals * 10)) / (decimals * 10);
    } else {
      value = Math.round(value);
    }
    return value;
  }

  patientUniqueIdFormat(uniqueId: number): string {

    if (!uniqueId) {
      return 'Not Assigned';
    }

    let value = '';
    if (uniqueId < 10) {
      value = ('000' + uniqueId)
    } else if (uniqueId < 100) {
      value = ('00' + uniqueId)
    } else if (uniqueId < 1000) {
      value = ('0' + uniqueId)
    } else {
      value = uniqueId.toString();
    }
    return value;
  }
}
